import Controller from "./captainPlan.controller";
import template from "./captainPlan.html";

const captainPlan = {
  template,
  controller: Controller,
  bindings: {
    captain: "<",
    captainPlan: "<",
    updateEvent: "<",
    addEvent: "<",
    showDialog: "<",
    showDialogInvokerEvent: "<",
  },
};

export default captainPlan;



// WEBPACK FOOTER //
// ./src/components/captainPlan/captainPlan.component.js